const firebaseConfig = {
    apiKey: "AIzaSyA_2yrnTgT5ZmmwZJ1ULhKE-gSCtl4U1BI",
    authDomain: "fashion-fare.firebaseapp.com",
    projectId: "fashion-fare",
    storageBucket: "fashion-fare.appspot.com",
    messagingSenderId: "1066503500358",
    appId: "1:1066503500358:web:f6d8eac5efe10a0c859047"
  };
  
  export default firebaseConfig;